module.exports = "/_next/static/images/24bde84122653fe81ee37fcf2f6e5087-hot-sale-hero-desktop.jpg.webp";